import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgCompass({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm3.311 2.924l.147-.022a1.5 1.5 0 011.64 1.644l-.022.143-.744 3.72a5 5 0 01-3.704 3.874l-.218.049-3.721.744a1.501 1.501 0 01-1.787-1.622l.022-.143.744-3.72a5 5 0 013.704-3.874l.218-.049 3.721-.744.147-.022-.147.022zm-.343 2.108l-2.985.597a3 3 0 00-2.31 2.168l-.044.186-.597 2.985 2.986-.597a3 3 0 002.31-2.168l.043-.185.597-2.986zM12 11a1 1 0 110 2 1 1 0 010-2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgCompass
